<template>
  <div>
    <!-- แถบแรก -->
    <b-card no-body>
      <b-card-header>
        <h4 class="card-title">
          รายการฝากเงิน
        </h4>
      </b-card-header>
      <div class="card-content">
        <b-card-body>
          <!-- Table Function -->
          <b-row class="mx-auto mb-1">
            <b-col cols="12 col-md-10" class="pr-1 pl-1 mb-1">
              <div>
                <b-input-group>

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_start_report"> วันที่ฝาก (จาก) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_start_report" id="date_start_report" class="form-control text-center" />

                  <b-input-group-prepend>
                    <span class="input-group-text" label="date_end_report"> วันที่ฝาก (ถึง) </span>
                  </b-input-group-prepend>
                  <flat-pickr v-model="date_end_report" id="date_end_report" class="form-control text-center" />

                </b-input-group>
              </div>
            </b-col>
            <b-col cols="12 col-md-2">
              <div class="btn-group">
                <b-button @click="fetch()" variant="btn-primary" class="btn bg-gradient-primary waves-effect waves-light"> ค้นหา </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- End Table Function -->
          <!-- Table Header -->
          <b-row>
            <b-col md="3" sm="2" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">แสดง</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" v-on:change="onPageSelect" style="width: 60px"/>
                <label class="d-inline-block text-sm-right ml-50">รายการ</label>
              </b-form-group>
            </b-col>
            <b-col md="5" sm="6" class="my-1">
              <b-row>
                <div class="btn-group btn-group-sm mx-auto" role="group">
                  <b-button variant="outline-secondary" class="btn" disabled>status: </b-button>
                  <b-button class="btn btn-warning" @click="sorted='status:0';fetch()">รอดำเนินการ</b-button>
                  <b-button class="btn btn-success" @click="sorted='status:1';fetch()">เติมแล้ว</b-button>
                  <b-button class="btn btn-danger" @click="sorted='status:2';fetch()">ไม่สำเร็จ</b-button>
                  <b-button class="btn btn-secondary" @click="sorted='status:3';fetch()">เติมทุน</b-button>
                  <b-button class="btn bg-gradient-primary" @click="sorted='';fetch()">ทั้งหมด</b-button>
                </div>
              </b-row>
            </b-col>
            <b-col md="4" sm="4" class="my-1">
              <b-form-group label="ค้นหา :" label-cols-sm="6" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0" >
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" v-on:change="onPageSelect" type="search" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"> ล้าง </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- End Table Header -->
          <!-- Table Body -->
          <b-row>
            <b-col cols="12">
              <b-table hover responsive style="min-height: 300px" :fields="fields" :items="items" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" show-empty>
                <template #empty="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #emptyfiltered="">
                  <div class="align-items-center text-center">ไม่พบข้อมูล</div>
                </template>
                <template #cell(username)="data">
                  <span class="text-primary">{{ data.value }}</span>
                </template>
                <template #cell(bank)="data">
                  <div class="media-aside media-left align-self-start">
                    <img
                      class="media-object rounded"
                      :src="BASE_URL + 'assets/app-assets/images/bank/' + bank_admin[data.value] + '.png'"
                      :title="(typeof(bank_list[data.value]) != undefined ? bank_list[data.value] : '-')"
                      alt="Bank"
                      height="40"
                      width="40"
                    >
                    <div class="align-items-center ml-1">
                      <h5>{{data.item.bank_number}}</h5>
                      <span class="text-success text-nowrap">
                        {{data.item.full_name}}
                      </span>
                    </div>
                  </div>
                </template>
                <template #cell(amount)="data">
                  <span class="text-success">{{ func.toMoney(data.value) }}</span>
                </template>
                <template #cell(bonus)="data">
                  <span class="text-warning">{{ func.toMoney(Number(data.item.sum_amount) - Number(data.item.amount)) }}</span>
                </template>
                <template #cell(sum_amount)="data">
                  <span class="text-primary">{{ func.toMoney(data.value) }} ฿</span>
                </template>
                <template #cell(status)="data">
                  <span v-if="data.value == 0" class="text-warning">รอดำเนินการ</span>
                  <span v-if="data.value == 1" class="text-success">เติมแล้ว</span>
                  <span v-if="data.value == 2" class="text-danger">ไม่สำเร็จ</span>
                  <span v-if="data.value >= 3" class="text-secondary">เติมทุน</span>
                </template>
                <template #cell(manage)="data">
                  <div class="btn-group">
                    <b-dropdown variant="link" toggle-class="bg-gradient-success waves-effect waves-light">
                      <template #button-content>
                        <span><feather-icon icon="EditIcon" class="font-medium-1 mr-1" /></span>จัดการ
                      </template>
                      <b-dropdown-item :to="'/deposit/deposit_form_detail/' + data.item.id"><span><feather-icon icon="SearchIcon" class="text-info mr-1" /></span>ตรวจสอบ</b-dropdown-item>
                      <template v-if="data.item.status == 0">
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="deposit_status('0', data.item)"><span><feather-icon icon="RefreshCwIcon" class="text-warning mr-1" /></span>เติมตรง</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="deposit_status('1', data.item)"><span><feather-icon icon="CheckIcon" class="text-info mr-1" /></span>เติมแล้ว</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="deposit_status('2', data.item)"><span><feather-icon icon="SlashIcon" class="text-danger mr-1" /></span>ไม่สำเร็จ</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="deposit_status('3', data.item)"><span><feather-icon icon="CreditCardIcon" class="text-secondary mr-1" /></span>เติมทุน</b-dropdown-item>
                      </template>
                      <template v-if="data.item.status == 2 && data.item.account_agent_username == ''">
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="deposit_status('3', data.item)"><span><feather-icon icon="CreditCardIcon" class="text-secondary mr-1" /></span>เติมทุน</b-dropdown-item>
                      </template>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- End Table Body -->
          <!-- Table Footer -->
          <b-row>
            <b-col sm="12" md="5">
              <div role="status" aria-live="polite">แสดง {{ func.show_page(perPage, currentPage) }} ถึง {{ func.show_page_to(perPage, currentPage, recordsTotal) }} จาก {{func.toNum(totalRows)}} รายการ (ค้นหา จากทั้งหมด {{perPage}} รายการ)</div>
            </b-col>
            <b-col sm="12" md="7">
              <b-pagination
                v-on:change="onPageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="end"
                size="sm"
                class="my-0"
                :first-number="true"
                :last-number="true"
              >
                <template #prev-text>‹ ย้อนกลับ</template>
                <template #next-text>ถัดไป ›</template>
              </b-pagination>
            </b-col>
          </b-row>
          <!-- End Table Footer -->
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบแรก -->
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCol, BRow, BTable, BInputGroup, BInputGroupPrepend, BFormInput, BButton, BFormGroup, BInputGroupAppend, BFormSelect,
  BPagination, BDropdown, BDropdownItem, BDropdownDivider,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import func from '@core/comp-functions/misc/func'

export default {
  components: {
    BCard, BCardHeader, BCardBody,
    BCol, BRow, BTable,
    BInputGroup, BInputGroupPrepend, BFormInput, BFormGroup, BInputGroupAppend,
    BButton,
    BFormSelect,
    BPagination,
    BDropdown, BDropdownItem, BDropdownDivider,
    flatPickr,
  },
  data() {
    return {
      func: func,
      BASE_URL: process.env.BASE_URL,
      date_start_report: '',
      date_end_report: '',
      draw: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 50,
      currentPage: 5,
      recordsTotal: 0,
      sorted: '',
      filter: '',
      filterOn: [],
      fields: [
        { key: 'username', label: 'ยูสเซอร์', class: 'text-center text-nowrap' },
        { key: 'bank', label: 'ชื่อ - นามสกุล', class: 'text-left' },
        { key: 'created_at', label: 'เวลารายการ', class: 'text-center text-nowrap' },
        { key: 'amount', label: 'จำนวนเงิน', class: 'text-center text-nowrap' },
        { key: 'bonus', label: 'โบนัส', class: 'text-center text-nowrap' },
        { key: 'sum_amount', label: 'รวม', class: 'text-center text-nowrap' },
        { key: 'status', label: 'สถานะ', class: 'text-center text-nowrap' },
        { key: 'manage', label: 'จัดการข้อมูล', class: 'text-center' },
      ],
      items: [],
      t_fetch: 0,
      bank_admin: {'01': '1', '02': '2', '03': '3', '04': '5', '05': '6', '06': '4', '07': '7', '08': '9', '09': 'baac'},
      bank_list: JSON.parse('{"01":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","02":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","03":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","04":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","05":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","06":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","07":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","08":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","09":"\u0e18.\u0e01.\u0e2a.","1":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","2":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","3":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","4":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","5":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","6":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","7":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","8":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","9":"\u0e18.\u0e01.\u0e2a."}'),
    }
  },
  mounted() {
    if (this.$route.query.ref) {
      this.filter = 'ref:' + this.$route.query.ref;
    }
    this.totalRows = this.items.length
    this.fetch()
    this.t_fetch = setInterval(() => {
      if (this.currentPage != 1) return;
      this.fetch()
    }, 1000 * 60)
  },
  watch: {
    filter: {
      handler() {
        this.fetch()
        this.totalRows = this.items.length
        this.currentPage = 1
      },
    }
  },
  methods: {
    onFiltered(filteredItems) {
      if (this.filter != '' && this.filter.startsWith('status:')) {
        this.filter = ''
      }
      // this.totalRows = filteredItems.length
      // this.currentPage = 1
    },
    onPageSelect() {
      let start = this.perPage * (this.currentPage - 1)
      this.fetch(start)
    },
    onPageChange(page) {
      let start = this.perPage * (page - 1)
      this.fetch(start)
    },
    loading() {
      this.$swal({
			  text: "กรุณารอสักครู่..",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: '',
        onBeforeOpen: () => {
          this.$swal.showLoading()
        },
      });
    },
    warn(text='') {
      this.$swal({
        title: 'แจ้งเตือน',
        text: text,
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    load(data) {
      if (data == null || data.data == null) return;
      this.draw = data.draw
      this.items = data.data
      this.totalRows = data.recordsFiltered
      this.recordsTotal = data.recordsTotal
    },
    fetch(start=0) {
      let url = `deposit/deposit_list_page?draw=${this.draw}&start=${start}&length=${this.perPage}&search%5Bvalue%5D=${this.sorted != '' ? this.sorted : this.filter}&date_start=${this.date_start_report}&date_end=${this.date_end_report}&status=&_=${Date.now()}`;
      this.$http.get(url).then(res => { this.load(res.data) })
    },
    deposit_status(type, data) {
      let { id, username, amount } = data;
      let url = '', text = '';
      switch (type) {
        case '0':
          url = 'deposit/deposit_credit/' + id
          text = 'ยืนยันการเติมเครดิตให้ ' + username + ' จำนวน ' + amount
          break;
        case '1':
          url = 'deposit/deposit_success/' + id
          text = 'ยืนยันการปรับรายการของ ' + username + ' เป็นเติมแล้ว'
          break;
        case '2':
          url = 'deposit/deposit_error/' + id
          text = 'ยืนยันการปรับรายการของ ' + username + ' เป็นไม่สำเร็จ'
          break;
        case '3':
          url = 'deposit/deposit_budget/' + id
          text = 'ยืนยันการปรับรายการของ ' + username + ' เป็นเติมทุน'
          break;
      }
      this.$swal({
        title: 'แจ้งเตือน',
        html: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
		    cancelButtonColor: 'red',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger mr-1',
        },
        buttonsStyling: false,
		    reverseButtons: true,
      }).then(result => {
        if (result.value) {
          this.loading()
          this.$http.post(url).then(res => {
            this.$swal.close()
            if (res.data.result) {
              this.fetch()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'ทำรายการสำเร็จ',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: res.data.message,
                },
              })
            } else {
              if(res.data.error && res.data.message != null) {
                this.warn(res.data.message)
              } else {
                this.warn('ทำรายการไม่สำเร็จ')
              }
              this.fetch()
            }
          }).catch((error) => {
            this.$swal.close()
            this.warn('ทำรายการไม่สำเร็จ error:'+error)
          })
        }
      })
    },
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.t_fetch)
    next()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
